<template>
  <div class="min-h-screen font-inter">
    <main class="w-full">
      <TalentDashboardComponent />
    </main>
  </div>
</template>

<script>
import TalentDashboardComponent from "@/components/TalentDashboardComponent.vue";

export default {
  name: "DashboardView",
  components: {
    TalentDashboardComponent,
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.token && this.$store.state.user;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
  },
  watch: {},
  mounted() {
    console.log("[DashboardView] Mounted");
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
/* Add your styles here */
</style>
